import { prop } from '@lib/style/theme';
import { CSSProperties } from 'react';
import { css } from 'styled-components';
import { unitStrict } from '../unit';
import { createCleaner, createPoints } from './utils';

export interface AnchorMixinProps {
    anchorPosition: CSSProperties['position'];
    anchorTop: string | number;
    anchorLeft: string | number;
    anchorBottom: string | number;
    anchorRight: string | number;
    anchorX: string | number;
    anchorY: string | number;
}

const detectAnchor = (prop: string, fallback: string, defaultValue: any) => (props) => {
    const size = props[prop];

    if (typeof size !== 'undefined' && size !== null) {
        return unitStrict(props[prop]);
    }

    return unitStrict(props[fallback] || defaultValue);
};

export const anchor = (position: CSSProperties['position'] = 'absolute', ...points) => {
    const [top, right, bottom, left] = createPoints(points);

    return css`
        & {
            position: ${prop('anchorPosition', position)};
            top: ${detectAnchor('anchorTop', 'anchorY', top)};
            bottom: ${detectAnchor('anchorBottom', 'anchorY', bottom)};
            left: ${detectAnchor('anchorLeft', 'anchorX', left)};
            right: ${detectAnchor('anchorRight', 'anchorX', right)};
        }
    `;
};

createCleaner(anchor, [
    'anchorPosition',
    'anchorTop',
    'anchorLeft',
    'anchorBottom',
    'anchorRight',
    'anchorX',
    'anchorY',
]);
